import { memo, type ReactNode } from 'react';

interface SectionRowProps {
  title: ReactNode;
  logo: ReactNode;
  description?: ReactNode;
  type?: string;
  action?: ReactNode;
}

export const ApplicationBlock = memo((props: SectionRowProps) => {
  const { title, description, type, logo, action } = props;
  return (
    <div className="flex justify-between rounded-lg border border-bolt-elements-borderColor bg-bolt-ds-surfaceTwo p-4">
      <div className="flex gap-4">
        <div className="size-10 bg-bolt-ds-surfaceOne rounded flex items-center justify-center p-2">{logo}</div>
        <div className="flex flex-col w-[85%]">
          {type && <div className={'text-xs text-bolt-elements-textSecondary w-full'}>{type}</div>}
          {title && <span className="text-base font-semibold text-bolt-elements-textPrimary">{title}</span>}
          {description && <div className={'text-sm text-bolt-elements-textSecondary w-full'}>{description}</div>}
        </div>
      </div>
      {action}
    </div>
  );
});
